// @ts-nocheck

import { CardModes } from '../../types/common';
import palette from '../palette';

import { withOpacity } from './helpers';

export const PercentDistribution = {
  step1: palette.red200,
  step2: palette.yellowwinamax450,
  step3: palette.greenwin,
  color: palette.neutralgrey350,
  backgroundColor: palette.bluegrey750,
  white: palette.white,
};

export const OddButton = {
  normal: {
    titleColor: palette.bluegrey925,
    backgroundColor: palette.white,
    valueColor: palette.red650,
    mmLogoBgColor: palette.bluegrey850,
    mmLogoColor: palette.redwinamax500,
    borderColor: palette.transparent,
  },
  active: {
    titleColor: palette.white,
    backgroundColor: palette.red200,
    valueColor: palette.white,
    mmLogoBgColor: palette.white,
    mmLogoColor: palette.redwinamax500,
    borderColor: palette.transparent,
  },
  disabled: {
    titleColor: palette.neutralgrey550,
    backgroundColor: palette.bluegrey800,
    valueColor: palette.neutralgrey350,
    mmLogoBgColor: palette.white,
    mmLogoColor: palette.redwinamax950,
    borderColor: palette.transparent,
  },
  mmAnyError: {
    titleColor: withOpacity(palette.white, '4c'),
    valueColor: withOpacity(palette.white, '4c'),
    borderColor: withOpacity(palette.white, '4c'),
    backgroundColor: palette.transparent,
    mmLogoBgColor: palette.white,
    mmLogoColor: palette.redwinamax950,
  },
  outlineBlue: {
    titleColor: palette.bluegrey500,
    backgroundColor: 'transparent',
    valueColor: palette.bluegrey500,
    borderColor: palette.bluegrey800,
  },
  outlineGreen: {
    titleColor: palette.greenwinamax350,
    backgroundColor: 'transparent',
    valueColor: palette.greenwinamax350,
    borderColor: `${palette.greenwinamax350}4D`, // opacity 30% (https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4)
  },
  blue: {
    titleColor: palette.bluegrey400,
    backgroundColor: palette.bluegrey800,
    valueColor: palette.bluegrey500,
  },
  green: {
    titleColor: palette.bluegrey925,
    backgroundColor: palette.greenwinamax350,
    valueColor: palette.bluegrey700,
  },
  [CardModes.BOOSTED]: {
    backgroundGradiant: palette.boostedodd,
    oldValueBackground: palette.bluegrey800,
    valueColor: palette.white,
    oldValueArrowBackground: palette.bluegrey800,
    borderColor: palette.bluegrey800,
    headerColor: palette.boostedoddheader,
  },
  [CardModes.BIG_BOOSTED]: {
    backgroundGradiant: palette.bigboostedodd,
    oldValueBackground: palette.bluegrey800,
    valueColor: palette.white,
    oldValueArrowBackground: palette.bluegrey800,
    borderColor: palette.yellowwinamax850,
    headerColor: palette.bigboostedoddheader,
  },
  [CardModes.XMAS_BOOSTED]: {
    backgroundGradiant: palette.xmasboostedodd,
    oldValueBackground: palette.bluegrey800,
    valueColor: palette.white,
    oldValueArrowBackground: palette.bluegrey800,
    borderColor: palette.redwinamax450,
    headerColor: palette.xmasboostedoddheader,
  },
};

export const HelperButton = {
  toggled: {
    backgroundColor: palette.neutralgrey950,
    color: palette.white,
  },
  default: {
    backgroundColor: palette.bluegrey800,
    color: palette.white,
  },
};

export const BetGroupLabel = {
  color: palette.neutralgrey350,
};

export const BetGroupOutcome = {
  starterColor: palette.neutralgrey400,
  lineColor: palette.neutralgrey800,
  color: palette.white,
};

export const BetGroupHeader = {
  backgroundColor: withOpacity(palette.bluegrey50, '11'),
  color: palette.neutralgrey200,
  separatorColor: withOpacity(palette.bluegrey50, '22'),
};

export const Match = {
  Separator: {
    backgroundColor: palette.neutralgrey700,
  },
  SubHeader: {
    backgroundColor: palette.bluegrey900,
  },
  Warnings: {
    AlertIcon: {
      outerColor: palette.yellowwinamax450,
    },
  },
  ToolBar: {
    backgroundColor: palette.bluegrey900,
    widgets: {
      svg: {
        fillColor: palette.white,
      },
      borderColor: palette.greyfooter,
      activeColor: palette.bluegrey750,
    },
  },
  GroupHeader: {
    backgroundColor: palette.bluegrey800,
    color: palette.white,
  },
  HelperText: {
    color: palette.neutralgrey350,
  },
  MatchCardHeader: {
    backgroundColor: palette.bluegrey850,
  },
  Header: {
    mmRadialColor: palette.redwinamax500,
  },
};

export const MatchBetGroup = {
  backgroundColor: palette.bluegrey900,
  separatorColor: palette.neutralgrey800,
};

export const MatchBetFilter = {
  selected: {
    backgroundColor: palette.bluegrey800,
    labelColor: palette.white,
    nbBetsColor: palette.neutralgrey450,
    borderColor: palette.white,
  },
  default: {
    labelColor: palette.white,
    nbBetsColor: palette.neutralgrey700,
    borderColor: palette.bluegrey800,
    backgroundColor: palette.black,
  },
};

export const MatchViewModeSwitch = {
  toggled: {
    mainBackgroundColor: palette.redwinamax500,
  },
};

export const MatchTitle = {
  score: {
    colorFinalScore: palette.bluegrey200,
    color: palette.yellowwinamax450,
    redCardBackgroundColor: palette.redwinamax700,
    redCardColor: palette.white,
    darkColor: palette.bluegrey300,
  },
  competitor: {
    color: palette.white,
  },
  title: {
    color: palette.white,
  },
};

export const HotEffect = {
  mainEffectColor: palette.redwinamax500,
};
